import axiosAPI from "../config/axiosInstance";

export const getCompanyStats = async () => {
  return axiosAPI("get", "company/stats");
};

export const fetchDashboardData = async () => {
  return axiosAPI("get", "dashboard/data");
};

export const requestProjectAccess = async (projectId) => {
  return axiosAPI("post", "project/request-access", { projectId });
};

export const updatePorjectAccessRequest = async (
  requestId,
  status,
  controls,
) => {
  return axiosAPI("post", "project/update-request-status", {
    requestId,
    status,
    controls,
  });
};
